module.exports = require('./src/plugin/retail');



//////////////////
// WEBPACK FOOTER
// ./~/@nsftx/seven-gravity-gateway/plugin-retail.js
// module id = 215
// module chunks = 0